import mapvalues from "lodash.mapvalues";
import { createRenderer as createFelaRenderer } from "fela";
import webPreset from "fela-preset-web";
import prefixer from "fela-plugin-prefixer";
import customPropertyPlugin from "fela-plugin-custom-property";
import namedKeys from "fela-plugin-named-keys";
import extend from "fela-plugin-extend";

import { breakpointOrder, breakpoints } from "~/styleguide";
import customProperties from "~/styleguide/custom-properties";

import globalStyles from "~/styleguide/global";

export const createRenderer = () => {
    const renderer = createFelaRenderer({
        selectorPrefix: "bb_",

        plugins: [
            ...webPreset,
            extend(),
            customPropertyPlugin(customProperties),
            namedKeys({
                ...mapvalues(breakpoints, (width, name) => {
                    const [_, type, dimension] = name.match(
                        /^(min|max)(Width|Height)/
                    );

                    return `@media (${type}-${dimension.toLowerCase()}: ${width}px)`;
                })
            }),
            prefixer()
        ],

        mediaQueryOrder: breakpointOrder.map(name => {
            const type = name.slice(0, 3);

            return `(${type}-width: ${breakpoints[name]}px)`;
        })
    });

    /**
     * Global FELA styles
     */
    renderer.renderStatic(globalStyles, "html,body");

    /**
     * Load static fonts
     */
     renderer.renderFont(
         "Ambit",
         [
             "/fonts/Ambit-Bold.woff2",
             "/fonts/Ambit-Bold.woff"
         ],
         {
             fontWeight: 700,
             fontDisplay: "swap"
         }
     );

     renderer.renderFont(
         "Ambit",
         [
             "/fonts/Ambit-BoldItalic.woff2",
             "/fonts/Ambit-BoldItalic.woff"
         ],
         {
             fontWeight: 700,
             fontStyle: "italic",
             fontDisplay: "swap"
         }
     );

     renderer.renderFont(
         "Ambit",
         [
             "/fonts/Ambit-SemiBold.woff2",
             "/fonts/Ambit-SemiBold.woff"
         ],
         {
             fontWeight: 600,
             fontDisplay: "swap"
         }
     );

     renderer.renderFont(
         "Ambit",
         [
             "/fonts/Ambit-SemiBoldItalic.woff2",
             "/fonts/Ambit-SemiBoldItalic.woff"
         ],
         {
             fontWeight: 600,
             fontStyle: "italic",
             fontDisplay: "swap"
         }
     );

     renderer.renderFont(
         "Ambit",
         [
             "/fonts/Ambit-Regular.woff2",
             "/fonts/Ambit-Regular.woff"
         ],
         {
             fontWeight: 400,
             fontDisplay: "swap"
         }
     );

     renderer.renderFont(
         "Ambit",
         [
             "/fonts/Ambit-Italic.woff2",
             "/fonts/Ambit-Italic.woff"
         ],
         {
             fontWeight: 400,
             fontStyle: "italic",
             fontDisplay: "swap"
         }
     );

    return renderer;
};
